import { PaymentReminderDocument } from "../pages/debitoren/mahnwesen/payment-reminder.types";
import { ReminderTemplateType } from "../pages/debitoren/mahnwesen/utils/reminder-stage";
import { PdfTemplateType } from "../pdf-templates/document-template.types";
import { AddressRecipient } from "../pdf-templates/utils";

const EXAMPLE_STAGE: Record<ReminderTemplateType, number> = {
	[PdfTemplateType.ZAHLUNGSERINNERUNG]: 1,
	[PdfTemplateType.ERSTE_MAHNUNG]: 2,
	[PdfTemplateType.FOLGEMAHNUNG]: 3,
	[PdfTemplateType.LETZTE_MAHNUNG]: 4,
};

export function getPaymentReminderDocumentExample(
	templateType: ReminderTemplateType,
	recipient: AddressRecipient
): PaymentReminderDocument {
	const stage = EXAMPLE_STAGE[templateType];
	const today = new Date().toISOString().split("T")[0];

	return {
		reminder: {
			id: 0,
			stage,
			template_type: templateType,
			sent_at: today,
			fee_amount: stage === 1 ? 0 : 20,
			deadline: today,
			voided_at: null,
			file_id: null,
			path_name: null,
		},
		invoice: {
			id: 0,
			doc_number: "000001",
			date: "2026-01-15",
			type: 0,
			value: 1234.56,
			currency: "CHF",
			bank_account_id: null,
			paid_amount: 200,
			open_amount: 1034.56,
			due_date: "2026-02-14",
		},
		fees:
			stage === 1
				? []
				: [
						{
							invoice_id: 0,
							doc_number: "000002",
							date: "2026-03-01",
							value: (stage - 1) * 20,
							open_amount: (stage - 1) * 20,
							vat_rate: 8.1,
						},
					],
		recipient: { ...recipient, kind: "client" },
		client: null,
	};
}
